"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LinkModal", {
  enumerable: true,
  get: function get() {
    return _LinkModal.default;
  }
});
var _LinkModal = _interopRequireDefault(require("./LinkModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }